import type { TablePaginationConfig, TableProps } from './InternalTable';
import Table from './Table';

export type { ColumnProps } from './Column';
export type { ColumnGroupType, ColumnType, ColumnsType } from './interface';
export type { Reference as TableRef } from 'rc-table';
export type { TablePaginationConfig, TableProps };

export default Table;
